import { render, staticRenderFns } from "./envSelect.vue?vue&type=template&id=2b2b0118&scoped=true"
import script from "./envSelect.vue?vue&type=script&lang=js"
export * from "./envSelect.vue?vue&type=script&lang=js"
import style0 from "./envSelect.vue?vue&type=style&index=0&id=2b2b0118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b0118",
  null
  
)

export default component.exports